import { render, staticRenderFns } from "./gns.vue?vue&type=template&id=0187366b&scoped=true"
import script from "./gns.vue?vue&type=script&lang=js"
export * from "./gns.vue?vue&type=script&lang=js"
import style0 from "./gns.vue?vue&type=style&index=0&id=0187366b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0187366b",
  null
  
)

export default component.exports